import { EcommerceAPI } from "../Client";

const getChildPayload = (payload = {}) => {
  if (payload?.dto) return payload.dto;

  const { productId, ...childPayload } = payload;
  return childPayload;
};

export const postProductChildrenApi = async (payload = {}) => {
  try {
    const response = await EcommerceAPI.post(
      `/product/children?productId=${payload?.productId || ""}`,
      getChildPayload(payload)
    );
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const updateProductChildrenApi = async (payload = {}) => {
  try {
    const response = await EcommerceAPI.put(
      `/product/children`,
      getChildPayload(payload)
    );
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const deleteProductChildrenApi = async (payload = {}) => {
  try {
    const id = payload?.id ?? payload;
    const response = await EcommerceAPI.delete(`/product/children?id=${id || ""}`);
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const getProductChildrenApi = async (payload = {}) => {
  try {
    const id = payload?.id ?? payload;
    const response = await EcommerceAPI.get(`/product/children/${id || ""}`);
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const getAllProductChildrenApi = async (payload = {}) => {
  try {
    const productId = payload?.productId ?? payload;
    const response = await EcommerceAPI.get(
      `/product/children/all?productId=${productId || ""}`
    );
    return response;
  } catch (error) {
    throw error.response || error;
  }
};
